module.exports = __webpack_public_path__ + "img/cloth_g1_shoe_04.161f6295.svg";